import React__default, { createElement } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var _ref = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 15H9v-2h2v2zm0-4H9V5h2v6z",
  opacity: 0.803
});

function SvgAlert(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref);
}

var AlertSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%3E%20%20%20%20%3Cpath%20fill%3D%22currentColor%22%20fill-rule%3D%22evenodd%22%20d%3D%22M10%200C4.48%200%200%204.48%200%2010s4.48%2010%2010%2010%2010-4.48%2010-10S15.52%200%2010%200zm1%2015H9v-2h2v2zm0-4H9V5h2v6z%22%20opacity%3D%22.803%22%2F%3E%3C%2Fsvg%3E";

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

var _ref$1 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M4 13V7H0l5-7 5 7H6v6H4z"
});

function SvgArrow(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    width: 10,
    height: 13
  }, props), _ref$1);
}

var ArrowSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2210%22%20height%3D%2213%22%20viewBox%3D%220%200%2010%2013%22%3E%20%20%20%20%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M4%2013V7H0l5-7%205%207H6v6H4z%22%20%2F%3E%3C%2Fsvg%3E";

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

var _ref$2 = /*#__PURE__*/createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/createElement("path", {
  d: "M2.412 0h1.01l2.411 5.833H4.462L3.979 4.6H1.824l-.467 1.233H0L2.412 0zm.482 1.692l-.678 1.817h1.356l-.678-1.817zM.833 12.148l2.669-3.51H.933V7.5h3.981v1.138l-2.625 3.51H5v1.185H.833z"
})), /*#__PURE__*/createElement("path", {
  d: "M10 12.5V.804",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/createElement("path", {
  d: "M12.278 9.313l-2.287 2.359-2.269-2.336a.633.633 0 00-.915 0 .681.681 0 000 .944l2.725 2.808a.633.633 0 00.915 0l2.746-2.83a.682.682 0 000-.945.633.633 0 00-.915 0z"
}));

function SvgAscending(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    width: 14,
    height: 14
  }, props), _ref$2);
}

var AscendingSvg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2214px%22%20height%3D%2214px%22%20viewBox%3D%220%200%2014%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EAscending%20Icon%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22screen%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Ent---Filtering-%26amp%3B-Sorting-1%22%20transform%3D%22translate%28-988.000000%2C%20-270.000000%29%22%20fill%3D%22currentColor%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-15%22%20transform%3D%22translate%28988.000000%2C%20270.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group%22%20transform%3D%22translate%28-0.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-17%22%20fill-rule%3D%22nonzero%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M2.41171404%2C0%20L3.42161929%2C0%20L5.83333333%2C5.83333333%20L4.46167097%2C5.83333333%20L3.97932817%2C4.600271%20L1.82385874%2C4.600271%20L1.35658915%2C5.83333333%20L0%2C5.83333333%20L2.41171404%2C0%20Z%20M2.89405685%2C1.69150858%20L2.21576227%2C3.50948509%20L3.57235142%2C3.50948509%20L2.89405685%2C1.69150858%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Path%22%20points%3D%220.833333333%2012.1476965%203.50171233%208.63821138%200.933219178%208.63821138%200.933219178%207.5%204.91438356%207.5%204.91438356%208.63821138%202.28881279%2012.1476965%205%2012.1476965%205%2013.3333333%200.833333333%2013.3333333%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Arrow%22%20transform%3D%22translate%2810.000000%2C%207.083333%29%20rotate%28-90.000000%29%20translate%28-10.000000%2C%20-7.083333%29%20translate%283.333333%2C%203.333333%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M1.25%2C3.75%20L12.9463907%2C3.75%22%20id%3D%22Line-5%22%20stroke%3D%22currentColor%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.82758735%2C1.86238692%20L2.54049016%2C4.22146834%20L0.271657278%2C1.88604732%20C0.0186627945%2C1.62508699%20-0.390592987%2C1.62508699%20-0.643587471%2C1.88604732%20C-0.896581954%2C2.14700765%20-0.896581954%2C2.56941545%20-0.643587471%2C2.82967989%20L2.0818531%2C5.63761308%20C2.33484758%2C5.89857342%202.74410337%2C5.89857342%202.99709785%2C5.63761308%20L5.7428321%2C2.80671538%20C5.99582658%2C2.54575505%205.99582658%2C2.12265136%205.7428321%2C1.86238692%20C5.48983761%2C1.60142658%205.08058183%2C1.60142658%204.82758735%2C1.86238692%20Z%22%20id%3D%22DROPDOWN-Copy-6%22%20transform%3D%22translate%282.549622%2C%203.750000%29%20rotate%28-270.000000%29%20translate%28-2.549622%2C%20-3.750000%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

var _ref$3 = /*#__PURE__*/createElement("path", {
  d: "M12.983 11.263a.329.329 0 00.006-.191l-.507-1.916a.325.325 0 10-.628.17l.306 1.157-5.346-3.125V1.123l.83.842a.324.324 0 00.46 0 .333.333 0 000-.466L6.72.096a.324.324 0 00-.46 0L4.873 1.5a.333.333 0 000 .466.324.324 0 00.46 0l.83-.842v6.235l-5.32 3.11.305-1.15a.325.325 0 10-.628-.171l-.503 1.901a.33.33 0 00.026.268c.05.088.135.141.226.157l1.867.506a.326.326 0 00.398-.232.33.33 0 00-.23-.403l-1.133-.308 5.318-3.108 5.336 3.12-1.127.305a.33.33 0 00.084.647.346.346 0 00.084-.011l1.893-.514a.324.324 0 00.212-.186l.011-.024v-.002z",
  fill: "currentColor"
});

function SvgAxis(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    "aria-hidden": "true",
    height: 12,
    width: 13
  }, props), _ref$3);
}

var AxisSvg = "data:image/svg+xml,%3Csvg%20aria-hidden%3D%22true%22%20focusable%3D%22false%22%20height%3D%2212%22%20viewBox%3D%220%200%2013%2012%22%20width%3D%2213%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%3Cpath%20d%3D%22m12.983%2011.263c.013-.04.019-.082.016-.125%200-.022-.004-.044-.01-.066l-.507-1.916c-.047-.176-.226-.28-.398-.233-.174.047-.277.228-.23.403l.306%201.157-5.346-3.125v-6.235l.83.842c.064.064.147.096.23.096.084%200%20.167-.032.23-.096.127-.129.127-.337%200-.466l-1.384-1.403c-.127-.128-.333-.128-.46%200l-1.387%201.404c-.127.129-.127.337%200%20.466.064.064.147.096.23.096s.166-.032.23-.096l.83-.842v6.235l-5.32%203.11.305-1.15c.047-.176-.056-.357-.23-.404-.173-.047-.351.057-.398.233l-.503%201.901c-.028.086-.023.183.026.268.05.088.135.141.226.157l1.867.506c.028.008.056.012.084.012.144%200%20.275-.097.314-.244.046-.176-.057-.356-.23-.403l-1.133-.308%205.318-3.108%205.336%203.12-1.127.305c-.173.047-.276.227-.23.403.04.147.17.244.314.244.028%200%20.056-.004.084-.011l1.893-.514c.099-.027.174-.098.212-.186l.011-.024v-.002z%22%20fill%3D%22currentColor%22%20%2F%3E%3C%2Fsvg%3E%20";

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

var _ref$4 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("path", {
  id: "burger-menu-back_svg__a",
  d: "M203.864 30v2h-17v-2h17zm-20.5-10.864l1.414 1.414-4.949 4.95 4.95 4.95-1.415 1.414L177 25.5l6.364-6.364zm20.5 4.864v2h-17v-2h17zm0-6v2h-17v-2h17z"
}));

var _ref2 = /*#__PURE__*/createElement("use", {
  fill: "currentColor",
  xlinkHref: "#burger-menu-back_svg__a",
  fillRule: "evenodd",
  transform: "translate(-166 -10)"
});

function SvgBurgerMenuBack(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    width: 49,
    height: 38
  }, props), _ref$4, _ref2);
}

var BurgerMenuBackSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20width%3D%2249%22%20height%3D%2238%22%20viewBox%3D%220%200%2049%2038%22%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cfilter%20id%3D%22prefix__a%22%20width%3D%22248.9%25%22%20height%3D%22385.7%25%22%20x%3D%22-74.4%25%22%20y%3D%22-114.3%25%22%20filterUnits%3D%22objectBoundingBox%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3CfeOffset%20dy%3D%224%22%20in%3D%22SourceAlpha%22%20result%3D%22shadowOffsetOuter1%22%2F%3E%20%20%20%20%20%20%20%20%20%20%20%20%3CfeGaussianBlur%20in%3D%22shadowOffsetOuter1%22%20result%3D%22shadowBlurOuter1%22%20stdDeviation%3D%226%22%2F%3E%20%20%20%20%20%20%20%20%20%20%20%20%3CfeColorMatrix%20in%3D%22shadowBlurOuter1%22%20values%3D%220%200%200%200%200.749946854%200%200%200%200%200.669667268%200%200%200%200%200.675080141%200%200%200%200.152428668%200%22%2F%3E%20%20%20%20%20%20%20%20%3C%2Ffilter%3E%20%20%20%20%20%20%20%20%3Cpath%20id%3D%22prefix__b%22%20d%3D%22M203.864%2030v2h-17v-2h17zm-20.5-10.864l1.414%201.414-4.949%204.95%204.95%204.95-1.415%201.414L177%2025.5l6.364-6.364zm20.5%204.864v2h-17v-2h17zm0-6v2h-17v-2h17z%22%2F%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20transform%3D%22translate%28-166%20-10%29%22%3E%20%20%20%20%20%20%20%20%3Cuse%20fill%3D%22currentColor%22%20xlink%3Ahref%3D%22%23prefix__b%22%2F%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

var _ref$5 = /*#__PURE__*/createElement("path", {
  d: "M0 0h17v2H0zm0 6h17v2H0zm0 6h17v2H0z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgBurgerMenu(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    width: 17,
    height: 14
  }, props), _ref$5);
}

var BurgerMenuSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2217%22%20height%3D%2214%22%20viewBox%3D%220%200%2017%2014%22%3E%20%20%20%20%3Cg%20fill%3D%22currentColor%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%200h17v2H0zM0%206h17v2H0zM0%2012h17v2H0z%22%2F%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$6.apply(this, arguments);
}

var _ref$6 = /*#__PURE__*/createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M0 3h20v17H0zm4-3h2v3H4zm10 0h2v3h-2z"
}), /*#__PURE__*/createElement("path", {
  fill: "#FFF",
  d: "M2 7h16v11H2z"
}), /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M5 9h2v2H5zm4 0h2v2H9zm4 0h2v2h-2zm-8 5h2v2H5zm4 0h2v2H9zm4 0h2v2h-2z"
}));

function SvgCalendar(props) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    width: 20,
    height: 20
  }, props), _ref$6);
}

var CalendarSvg = "data:image/svg+xml,%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M0%203h20v17H0zM4%200h2v3H4zM14%200h2v3h-2z%22%2F%3E%20%20%20%20%3Cpath%20fill%3D%22%23FFF%22%20d%3D%22M2%207h16v11H2z%22%2F%3E%20%20%20%20%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M5%209h2v2H5zM9%209h2v2H9zM13%209h2v2h-2zM5%2014h2v2H5zM9%2014h2v2H9zM13%2014h2v2h-2z%22%2F%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7.apply(this, arguments);
}

var _ref$7 = /*#__PURE__*/createElement("path", {
  d: "M10.4 8h1.2c.2 0 .4-.2.4-.4V3.4c0-.2-.2-.4-.4-.4h-1.2c-.2 0-.4.2-.4.4v4.2c0 .2.2.4.4.4zm3 0h1.2c.2 0 .4-.2.4-.4V.4c0-.2-.2-.4-.4-.4h-1.2c-.2 0-.4.2-.4.4v7.2c0 .2.2.4.4.4zm-9 0h1.2c.2 0 .4-.2.4-.4V5.4c0-.2-.2-.4-.4-.4H4.4c-.2 0-.4.2-.4.4v2.2c0 .2.2.4.4.4zm3 0h1.2c.2 0 .4-.2.4-.4V1.4c0-.2-.2-.4-.4-.4H7.4c-.2 0-.4.2-.4.4v6.2c0 .2.2.4.4.4zm8.1 2H2V.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V11a1 1 0 001 1h14.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgChartBar(props) {
  return /*#__PURE__*/createElement("svg", _extends$7({
    width: 16,
    height: 12
  }, props), _ref$7);
}

var ChartBarSvg = "data:image/svg+xml,%3Csvg%20width%3D%2216px%22%20height%3D%2212px%22%20viewBox%3D%220%200%2016%2012%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Ctitle%3Echart-bar%3C%2Ftitle%3E%20%20%20%20%3Cg%20id%3D%22Analysis---V.2---Asset-Only%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%221.2.1_-Generate-portfolios---Configuration-Copy-15%22%20transform%3D%22translate%28-1387.000000%2C%20-261.000000%29%22%20fill%3D%22currentColor%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-9%22%20transform%3D%22translate%281080.000000%2C%20251.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Vertical-tab-Copy%22%20transform%3D%22translate%28300.000000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Axis%22%20transform%3D%22translate%286.500000%2C%2010.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22chart-bar%22%20transform%3D%22translate%280.500000%2C%200.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M10.4%2C8%20L11.6%2C8%20C11.8%2C8%2012%2C7.8%2012%2C7.6%20L12%2C3.4%20C12%2C3.2%2011.8%2C3%2011.6%2C3%20L10.4%2C3%20C10.2%2C3%2010%2C3.2%2010%2C3.4%20L10%2C7.6%20C10%2C7.8%2010.2%2C8%2010.4%2C8%20L10.4%2C8%20Z%20M13.4%2C8%20L14.6%2C8%20C14.8%2C8%2015%2C7.8%2015%2C7.6%20L15%2C0.4%20C15%2C0.2%2014.8%2C0%2014.6%2C0%20L13.4%2C0%20C13.2%2C0%2013%2C0.2%2013%2C0.4%20L13%2C7.6%20C13%2C7.8%2013.2%2C8%2013.4%2C8%20Z%20M4.4%2C8%20L5.6%2C8%20C5.8%2C8%206%2C7.8%206%2C7.6%20L6%2C5.4%20C6%2C5.2%205.8%2C5%205.6%2C5%20L4.4%2C5%20C4.2%2C5%204%2C5.2%204%2C5.4%20L4%2C7.6%20C4%2C7.8%204.2%2C8%204.4%2C8%20Z%20M7.4%2C8%20L8.6%2C8%20C8.8%2C8%209%2C7.8%209%2C7.6%20L9%2C1.4%20C9%2C1.2%208.8%2C1%208.6%2C1%20L7.4%2C1%20C7.2%2C1%207%2C1.2%207%2C1.4%20L7%2C7.6%20C7%2C7.8%207.2%2C8%207.4%2C8%20L7.4%2C8%20Z%20M15.5%2C10%20L2%2C10%20L2%2C0.5%20C2%2C0.22375%201.77625%2C0%201.5%2C0%20L0.5%2C0%20C0.22375%2C0%200%2C0.22375%200%2C0.5%20L0%2C11%20C0%2C11.5521875%200.4478125%2C12%201%2C12%20L15.5%2C12%20C15.77625%2C12%2016%2C11.77625%2016%2C11.5%20L16%2C10.5%20C16%2C10.22375%2015.77625%2C10%2015.5%2C10%20Z%22%20id%3D%22Shape%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$8() {
  _extends$8 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$8.apply(this, arguments);
}

var _ref$8 = /*#__PURE__*/createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  d: "M10 0H6v14h4zM16 4h-4v10h4zM4 7H0v7h4z"
}));

function SvgChart(props) {
  return /*#__PURE__*/createElement("svg", _extends$8({
    width: 16,
    height: 14
  }, props), _ref$8);
}

var ChartSvg = "data:image/svg+xml,%3Csvg%20width%3D%2216px%22%20height%3D%2214px%22%20viewBox%3D%220%200%2016%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-416.000000%2C%20-1819.000000%29%22%20fill%3D%22currentColor%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28438.000000%2C%201826.000000%29%20rotate%28-180.000000%29%20translate%28-438.000000%2C%20-1826.000000%29%20translate%28410.000000%2C%201812.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%2842.000000%2C%2014.000000%29%20rotate%28-180.000000%29%20translate%28-42.000000%2C%20-14.000000%29%20translate%2834.000000%2C%207.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20transform%3D%22translate%288.000000%2C%207.000000%29%20scale%28-1%2C%201%29%20translate%28-8.000000%2C%20-7.000000%29%20%22%20x%3D%226%22%20y%3D%220%22%20width%3D%224%22%20height%3D%2214%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20transform%3D%22translate%2814.000000%2C%209.000000%29%20scale%28-1%2C%201%29%20translate%28-14.000000%2C%20-9.000000%29%20%22%20x%3D%2212%22%20y%3D%224%22%20width%3D%224%22%20height%3D%2210%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20transform%3D%22translate%282.000000%2C%2010.500000%29%20scale%28-1%2C%201%29%20translate%28-2.000000%2C%20-10.500000%29%20%22%20x%3D%220%22%20y%3D%227%22%20width%3D%224%22%20height%3D%227%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$9() {
  _extends$9 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$9.apply(this, arguments);
}

var _ref$9 = /*#__PURE__*/createElement("path", {
  d: "M6.693 1.735L3.99 4.565 1.307 1.764a.741.741 0 00-1.083-.001.828.828 0 000 1.133l3.223 3.37c.3.312.783.312 1.082 0l3.247-3.398a.828.828 0 000-1.133.742.742 0 00-1.083 0z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgChevronDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$9({
    width: 8,
    height: 8
  }, props), _ref$9);
}

var ChevronDownSvg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%228px%22%20height%3D%228px%22%20viewBox%3D%220%200%208%208%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%280.000000%2C%201.000000%29%22%20fill%3D%22currentColor%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M6.693%2C0.735%20L3.99%2C3.565%20L1.307%2C0.764%20C1.007%2C0.45%200.523%2C0.45%200.224%2C0.763%20C-0.075%2C1.076%20-0.075%2C1.583%200.224%2C1.896%20L3.447%2C5.266%20C3.747%2C5.578%204.23%2C5.578%204.529%2C5.266%20L7.776%2C1.868%20C8.075%2C1.555%208.075%2C1.048%207.776%2C0.735%20C7.476%2C0.422%206.993%2C0.422%206.693%2C0.735%20Z%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$a() {
  _extends$a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$a.apply(this, arguments);
}

var _ref$a = /*#__PURE__*/createElement("path", {
  d: "M1.735 1.307l2.83 2.703-2.801 2.683a.741.741 0 00-.001 1.083.828.828 0 001.133 0l3.37-3.223a.742.742 0 000-1.082L2.868.224a.828.828 0 00-1.133 0 .742.742 0 000 1.083z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgChevronRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$a({
    width: 8,
    height: 8
  }, props), _ref$a);
}

var ChevronRightSvg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%228px%22%20height%3D%228px%22%20viewBox%3D%220%200%208%208%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%284.000000%2C%204.000000%29%20rotate%28270.000000%29%20translate%28-4.000000%2C%20-4.000000%29%20translate%280.000000%2C%201.000000%29%22%20fill%3D%22currentColor%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M6.693%2C0.735%20L3.99%2C3.565%20L1.307%2C0.764%20C1.007%2C0.45%200.523%2C0.45%200.224%2C0.763%20C-0.075%2C1.076%20-0.075%2C1.583%200.224%2C1.896%20L3.447%2C5.266%20C3.747%2C5.578%204.23%2C5.578%204.529%2C5.266%20L7.776%2C1.868%20C8.075%2C1.555%208.075%2C1.048%207.776%2C0.735%20C7.476%2C0.422%206.993%2C0.422%206.693%2C0.735%20Z%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$b() {
  _extends$b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$b.apply(this, arguments);
}

var _ref$b = /*#__PURE__*/createElement("path", {
  d: "M1.64.36L8 6.73 14.36.36l.71.71L8 8.14.93 1.07l.7-.7z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgChevronThin(props) {
  return /*#__PURE__*/createElement("svg", _extends$b({
    "aria-hidden": "true",
    width: 16,
    height: 8
  }, props), _ref$b);
}

var ChevronThin = "data:image/svg+xml,%3Csvg%20aria-hidden%3D%22true%22%20focusable%3D%22false%22%20width%3D%2216%22%20height%3D%228%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20d%3D%22M1.64.36L8%206.73%2014.36.36l.71.71L8%208.14.93%201.07l.7-.7z%22%20fill%3D%22currentColor%22%20fill-rule%3D%22evenodd%22%20%2F%3E%3C%2Fsvg%3E";

function _extends$c() {
  _extends$c = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$c.apply(this, arguments);
}

var _ref$c = /*#__PURE__*/createElement("path", {
  d: "M1.326 4.765l2.745-2.83 2.722 2.802a.76.76 0 001.098 0 .818.818 0 000-1.133L4.621.234a.76.76 0 00-1.098 0L.228 3.633a.819.819 0 000 1.133.76.76 0 001.098 0z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgChevronUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$c({
    width: 9,
    height: 8,
    viewBox: "0 0 9 5"
  }, props), _ref$c);
}

var ChevronUpSvg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%229px%22%20height%3D%228px%22%20viewBox%3D%220%200%209%205%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20id%3D%22screen%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Ent---Edit-Columns%22%20transform%3D%22translate%28-1383.000000%2C%20-729.000000%29%22%20fill%3D%22currentColor%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M1389.7931%2C729.234864%20L1387.04859%2C732.065762%20L1384.32599%2C729.263257%20C1384.0224%2C728.950104%201383.53129%2C728.950104%201383.2277%2C729.263257%20C1382.9241%2C729.576409%201382.9241%2C730.083299%201383.2277%2C730.395616%20L1386.49822%2C733.765136%20C1386.80182%2C734.078288%201387.29292%2C734.078288%201387.59652%2C733.765136%20L1390.8914%2C730.368058%20C1391.19499%2C730.054906%201391.19499%2C729.547182%201390.8914%2C729.234864%20C1390.58781%2C728.921712%201390.0967%2C728.921712%201389.7931%2C729.234864%20Z%22%20id%3D%22DROPDOWN-Copy-5%22%20transform%3D%22translate%281387.059547%2C%20731.500000%29%20rotate%28-180.000000%29%20translate%28-1387.059547%2C%20-731.500000%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$d() {
  _extends$d = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$d.apply(this, arguments);
}

var _ref$d = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.571 0L10 1.429l-3.572 3.57L10 8.571 8.571 10 5 6.428 1.429 10 0 8.571 3.572 5 0 1.429 1.429 0 5 3.571 8.571 0z"
});

function SvgClose(props) {
  return /*#__PURE__*/createElement("svg", _extends$d({
    width: 10,
    height: 10
  }, props), _ref$d);
}

var CloseSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2210%22%20height%3D%2210%22%20viewBox%3D%220%200%2010%2010%22%3E%20%20%20%20%3Cpath%20fill%3D%22currentColor%22%20fill-rule%3D%22evenodd%22%20d%3D%22M8.571%200L10%201.429l-3.572%203.57L10%208.571%208.571%2010%205%206.428%201.429%2010%200%208.571%203.572%205%200%201.429%201.429%200%205%203.571%208.571%200z%22%2F%3E%3C%2Fsvg%3E";

function _extends$e() {
  _extends$e = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$e.apply(this, arguments);
}

var _ref$e = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M9.625 10.25h-.946a.375.375 0 00-.375.375v1.776H3.5V7.75h3.125A.375.375 0 007 7.375v-.75a.375.375 0 00-.375-.375H3.5V3.841c0-1.17.837-2.106 2.28-2.106.81 0 1.522.372 1.892.608.16.103.373.068.493-.08l.614-.76a.375.375 0 00-.074-.541C8.21.608 7.157 0 5.76 0 3.304 0 1.5 1.599 1.5 3.763V6.25H.625a.375.375 0 00-.375.375v.75c0 .207.168.375.375.375H1.5v4.651H.375a.375.375 0 00-.375.375v.849c0 .207.168.375.375.375h9.25a.375.375 0 00.375-.375v-3a.375.375 0 00-.375-.375z"
});

function SvgCurrencyGbp(props) {
  return /*#__PURE__*/createElement("svg", _extends$e({
    width: 10,
    height: 14
  }, props), _ref$e);
}

var CurrencyGbpSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2210%22%20height%3D%2214%22%20viewBox%3D%220%200%2010%2014%22%3E%20%20%3Cpath%20fill%3D%22currentColor%22%20fill-rule%3D%22nonzero%22%20d%3D%22M9.625%2010.25h-.946a.375.375%200%2000-.375.375v1.776H3.5V7.75h3.125A.375.375%200%20007%207.375v-.75a.375.375%200%2000-.375-.375H3.5V3.841c0-1.17.837-2.106%202.28-2.106.81%200%201.522.372%201.892.608.16.103.373.068.493-.08l.614-.76a.375.375%200%2000-.074-.541C8.21.608%207.157%200%205.76%200%203.304%200%201.5%201.599%201.5%203.763V6.25H.625a.375.375%200%2000-.375.375v.75c0%20.207.168.375.375.375H1.5v4.651H.375a.375.375%200%2000-.375.375v.849c0%20.207.168.375.375.375h9.25a.375.375%200%2000.375-.375v-3a.375.375%200%2000-.375-.375z%22%2F%3E%3C%2Fsvg%3E";

function _extends$f() {
  _extends$f = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$f.apply(this, arguments);
}

var _ref$f = /*#__PURE__*/createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M3 8h12v2H3z"
});

function SvgDashWhite(props) {
  return /*#__PURE__*/createElement("svg", _extends$f({
    width: 18,
    height: 18
  }, props), _ref$f);
}

var DashWhiteSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%20%20%3Cpath%20fill%3D%22%23FFF%22%20fill-rule%3D%22evenodd%22%20d%3D%22M3%208h12v2H3z%22%2F%3E%3C%2Fsvg%3E";

function _extends$g() {
  _extends$g = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$g.apply(this, arguments);
}

var _ref$g = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3 8h12v2H3z"
});

function SvgDash(props) {
  return /*#__PURE__*/createElement("svg", _extends$g({
    width: 18,
    height: 18
  }, props), _ref$g);
}

var DashSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%20%20%3Cpath%20fill%3D%22currentColor%22%20fill-rule%3D%22evenodd%22%20d%3D%22M3%208h12v2H3z%22%2F%3E%3C%2Fsvg%3E";

function _extends$h() {
  _extends$h = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$h.apply(this, arguments);
}

var _ref$h = /*#__PURE__*/createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  d: "M2.315 7.5h.97L5.6 13.333H4.283L3.82 12.1H1.75l-.448 1.233H0L2.315 7.5zm.463 1.692l-.65 1.817h1.301l-.65-1.817zM.8 4.648l2.562-3.51H.896V0h3.822v1.138l-2.52 3.51H4.8v1.185h-4z",
  fillRule: "nonzero"
}), /*#__PURE__*/createElement("path", {
  d: "M9.6 12.283V1.055",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}), /*#__PURE__*/createElement("path", {
  d: "M11.878 9.224l-2.287 2.264-2.269-2.242a.651.651 0 00-.915 0 .635.635 0 000 .906l2.725 2.696c.253.25.662.25.915 0l2.746-2.718a.636.636 0 000-.906.651.651 0 00-.915 0z"
}));

function SvgDescending(props) {
  return /*#__PURE__*/createElement("svg", _extends$h({
    width: 13,
    height: 14
  }, props), _ref$h);
}

var DescendingSvg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2213px%22%20height%3D%2214px%22%20viewBox%3D%220%200%2013%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3EDescending%20Icon%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22screen%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Ent---Filtering-%26amp%3B-Sorting-1%22%20transform%3D%22translate%28-988.000000%2C%20-303.000000%29%22%20fill%3D%22currentColor%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-27%22%20transform%3D%22translate%28988.000000%2C%20303.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M2.31524548%2C7.5%20L3.28475452%2C7.5%20L5.6%2C13.3333333%20L4.28320413%2C13.3333333%20L3.82015504%2C12.100271%20L1.75090439%2C12.100271%20L1.30232558%2C13.3333333%20L-7.27418126e-13%2C13.3333333%20L2.31524548%2C7.5%20Z%20M2.77829457%2C9.19150858%20L2.12713178%2C11.0094851%20L3.42945736%2C11.0094851%20L2.77829457%2C9.19150858%20Z%22%20id%3D%22Shape%22%20fill-rule%3D%22nonzero%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Path%22%20fill-rule%3D%22nonzero%22%20points%3D%220.8%204.64769648%203.36164384%201.13821138%200.895890411%201.13821138%200.895890411%208.8817842e-16%204.71780822%208.8817842e-16%204.71780822%201.13821138%202.19726027%204.64769648%204.8%204.64769648%204.8%205.83333333%200.8%205.83333333%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Arrow%22%20transform%3D%22translate%289.850000%2C%206.983333%29%20rotate%28-90.000000%29%20translate%28-9.850000%2C%20-6.983333%29%20translate%283.350000%2C%202.983333%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M1.2%2C3.75%20L12.4285351%2C3.75%22%20id%3D%22Line-5%22%20stroke%3D%22currentColor%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M4.72560245%2C1.93789144%20L2.43850527%2C4.2026096%20L0.169672385%2C1.96060543%20C-0.0833220979%2C1.71008351%20-0.49257788%2C1.71008351%20-0.745572363%2C1.96060543%20C-0.998566847%2C2.21112735%20-0.998566847%2C2.61663883%20-0.745572363%2C2.86649269%20L1.97986821%2C5.56210856%20C2.23286269%2C5.81263048%202.64211847%2C5.81263048%202.89511296%2C5.56210856%20L5.6408472%2C2.84444676%20C5.89384169%2C2.59392484%205.89384169%2C2.1877453%205.6408472%2C1.93789144%20C5.38785272%2C1.68736952%204.97859694%2C1.68736952%204.72560245%2C1.93789144%20Z%22%20id%3D%22DROPDOWN-Copy-6%22%20transform%3D%22translate%282.447637%2C%203.750000%29%20rotate%28-270.000000%29%20translate%28-2.447637%2C%20-3.750000%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$i() {
  _extends$i = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$i.apply(this, arguments);
}

var _ref$i = /*#__PURE__*/createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/createElement("path", {
  d: "M10 15l6-8H4z"
}), /*#__PURE__*/createElement("path", {
  d: "M0 19h20v2H0zm0-4h2v4H0zm18 0h2v4h-2zM9 0h2v10H9z"
}));

function SvgDownload(props) {
  return /*#__PURE__*/createElement("svg", _extends$i({
    width: 20,
    height: 21
  }, props), _ref$i);
}

var DownloadSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%2221%22%20viewBox%3D%220%200%2020%2021%22%3E%20%20%20%20%3Cg%20fill%3D%22currentColor%22%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M10%207L16%2015%204%2015z%22%20transform%3D%22matrix%281%200%200%20-1%200%2022%29%22%2F%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M0%2019H20V21H0zM0%2015H2V19H0zM18%2015H20V19H18zM9%200H11V10H9z%22%2F%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$j() {
  _extends$j = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$j.apply(this, arguments);
}

var _ref$j = /*#__PURE__*/createElement("path", {
  d: "M12 1.048l-4.364 4.19v2.62L4.364 11V5.238L0 1.048V0h12v1.048zm-10.364 0l3.819 3.666v3.667l1.09-1.048V4.714l3.819-3.666H1.636z",
  fill: "currentColor"
});

function SvgFilterOutline(props) {
  return /*#__PURE__*/createElement("svg", _extends$j({
    "aria-hidden": "true",
    height: 11,
    width: 12
  }, props), _ref$j);
}

var FilterOutlineSvg = "data:image/svg+xml,%3Csvg%20aria-hidden%3D%22true%22%20focusable%3D%22false%22%20height%3D%2211%22%20viewBox%3D%220%200%2012%2011%22%20width%3D%2212%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20d%3D%22M12%201.048l-4.364%204.19v2.62L4.364%2011V5.238L0%201.048V0h12v1.048zm-10.364%200l3.819%203.666v3.667l1.09-1.048V4.714l3.819-3.666H1.636z%22%20fill%3D%22currentColor%22%20fillRule%3D%22evenodd%22%20%2F%3E%3C%2Fsvg%3E";

function _extends$k() {
  _extends$k = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$k.apply(this, arguments);
}

var _ref$k = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M4.056 11l2.819-2.2V5.844L11 0H0l4.056 5.844z"
});

function SvgFilter(props) {
  return /*#__PURE__*/createElement("svg", _extends$k({
    width: 11,
    height: 11
  }, props), _ref$k);
}

var FilterSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2211%22%20height%3D%2211%22%20viewBox%3D%220%200%2011%2011%22%3E%20%20%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20id%3D%22Funnel%22%3E%20%20%20%20%20%20%20%20%3Cpath%20fill%3D%22currentColor%22%20fill-rule%3D%22nonzero%22%20d%3D%22M4.056%2011l2.819-2.2V5.844L11%200H0l4.056%205.844z%22%2F%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$l() {
  _extends$l = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$l.apply(this, arguments);
}

var _ref$l = /*#__PURE__*/createElement("path", {
  d: "M5.5 2l7 7-7 7",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgLargerChevronRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$l({
    width: 18,
    height: 18
  }, props), _ref$l);
}

var LargerChevronRightSvg = "data:image/svg+xml,%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%3E%20%20%3Cpath%20d%3D%22M5.5%202%20l7%207%20l-7%207%22%20fill%3D%22none%22%20stroke%3D%22currentColor%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

function _extends$m() {
  _extends$m = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$m.apply(this, arguments);
}

var _ref$m = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("filter", {
  filterUnits: "objectBoundingBox",
  y: "-114.3%",
  x: "-74.4%",
  height: "385.7%",
  width: "248.9%",
  id: "menu-close_svg__b"
}, /*#__PURE__*/createElement("feGaussianBlur", {
  stdDeviation: 3
})), /*#__PURE__*/createElement("path", {
  d: "M37.429 20.145v2h-17v-2h17zm-20.5-10.864l1.414 1.414-4.949 4.95 4.95 4.95-1.415 1.414-6.364-6.364 6.364-6.364zm20.5 4.864v2h-17v-2h17zm0-6v2h-17v-2h17z",
  id: "menu-close_svg__a"
}));

var _ref2$1 = /*#__PURE__*/createElement("path", {
  fill: "none",
  d: "M-1-1h51v32H-1z"
});

var _ref3 = /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", {
  fillRule: "evenodd",
  fill: "currentColor"
}, /*#__PURE__*/createElement("use", {
  xlinkHref: "#menu-close_svg__a",
  filter: "url(#menu-close_svg__b)",
  fillOpacity: 0.8
}), /*#__PURE__*/createElement("use", {
  xlinkHref: "#menu-close_svg__a"
})));

function SvgMenuClose(props) {
  return /*#__PURE__*/createElement("svg", _extends$m({
    width: 49,
    height: 30
  }, props), _ref$m, _ref2$1, _ref3);
}

var MenuCloseSvg = "data:image/svg+xml,%3Csvg%20width%3D%2249%22%20height%3D%2230%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%3Cdefs%3E%20%20%3Cpath%20d%3D%22m37.429%2C20.145l0%2C2l-17%2C0l0%2C-2l17%2C0zm-20.5%2C-10.864l1.414%2C1.414l-4.949%2C4.95l4.95%2C4.95l-1.415%2C1.414l-6.364%2C-6.364l6.364%2C-6.364zm20.5%2C4.864l0%2C2l-17%2C0l0%2C-2l17%2C0zm0%2C-6l0%2C2l-17%2C0l0%2C-2l17%2C0z%22%20id%3D%22b%22%2F%3E%20%20%3Cfilter%20filterUnits%3D%22objectBoundingBox%22%20y%3D%22-114.3%25%22%20x%3D%22-74.4%25%22%20height%3D%22385.7%25%22%20width%3D%22248.9%25%22%20id%3D%22a%22%3E%20%20%20%3CfeGaussianBlur%20stdDeviation%3D%223%22%2F%3E%20%20%3C%2Ffilter%3E%20%3C%2Fdefs%3E%20%3Cg%3E%20%20%3Ctitle%3Ebackground%3C%2Ftitle%3E%20%20%3Crect%20fill%3D%22none%22%20id%3D%22canvas_background%22%20height%3D%2232%22%20width%3D%2251%22%20y%3D%22-1%22%20x%3D%22-1%22%2F%3E%20%3C%2Fg%3E%20%3Cg%3E%20%20%3Ctitle%3ELayer%201%3C%2Ftitle%3E%20%20%3Cg%20id%3D%22svg_1%22%20fill-rule%3D%22evenodd%22%20fill%3D%22currentColor%22%3E%20%20%20%3Cuse%20id%3D%22svg_2%22%20xlink%3Ahref%3D%22%23b%22%20filter%3D%22url%28%23a%29%22%20fill%3D%22currentColor%22%20fill-opacity%3D%220.8%22%2F%3E%20%20%20%3Cuse%20id%3D%22svg_3%22%20xlink%3Ahref%3D%22%23b%22%20fill%3D%22currentColor%22%2F%3E%20%20%3C%2Fg%3E%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$n() {
  _extends$n = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$n.apply(this, arguments);
}

var _ref$n = /*#__PURE__*/createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/createElement("circle", {
  r: 4.7,
  cx: 33.3,
  cy: 19.7
}), /*#__PURE__*/createElement("circle", {
  r: 4.7,
  cx: 33.3,
  cy: 33
}), /*#__PURE__*/createElement("circle", {
  r: 4.7,
  cx: 33.3,
  cy: 46.3
}));

function SvgOptions(props) {
  return /*#__PURE__*/createElement("svg", _extends$n({
    width: 30,
    height: 30,
    viewBox: "0 0 64 64"
  }, props), _ref$n);
}

var OptionsSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2230%22%20height%3D%2230%22%20viewBox%3D%220%200%2064%2064%22%3E%20%20%3Cg%20fill%3D%22currentColor%22%3E%20%20%20%20%3Ccircle%20r%3D%224.7%22%20cx%3D%2233.3%22%20cy%3D%2219.7%22%3E%3C%2Fcircle%3E%20%20%20%20%3Ccircle%20r%3D%224.7%22%20cx%3D%2233.3%22%20cy%3D%2233%22%3E%3C%2Fcircle%3E%20%20%20%20%3Ccircle%20r%3D%224.7%22%20cx%3D%2233.3%22%20cy%3D%2246.3%22%3E%3C%2Fcircle%3E%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$o() {
  _extends$o = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$o.apply(this, arguments);
}

var _ref$o = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M3.016 6C4.663 6 6 4.656 6 3S4.663 0 3.016 0C1.368 0 .03 1.344.03 3s1.337 3 2.985 3zm0-4.5c.823 0 1.492.672 1.492 1.5s-.669 1.5-1.492 1.5c-.824 0-1.493-.672-1.493-1.5s.669-1.5 1.493-1.5zM8.984 8C7.337 8 6 9.344 6 11s1.337 3 2.984 3c1.648 0 2.985-1.344 2.985-3s-1.337-3-2.985-3zm0 4.5c-.823 0-1.492-.672-1.492-1.5s.669-1.5 1.492-1.5c.824 0 1.493.672 1.493 1.5s-.669 1.5-1.493 1.5zM11.904.588L1.809 13.844a.376.376 0 01-.301.156H.404a.375.375 0 01-.31-.584L10.203.156a.374.374 0 01.3-.156h1.092c.298 0 .476.338.308.588z"
});

function SvgPercentage(props) {
  return /*#__PURE__*/createElement("svg", _extends$o({
    width: 12,
    height: 14
  }, props), _ref$o);
}

var PercentageSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2214%22%20viewBox%3D%220%200%2012%2014%22%3E%20%20%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M3.016%206C4.663%206%206%204.656%206%203S4.663%200%203.016%200C1.368%200%20.03%201.344.03%203s1.337%203%202.985%203zm0-4.5c.823%200%201.492.672%201.492%201.5s-.669%201.5-1.492%201.5c-.824%200-1.493-.672-1.493-1.5s.669-1.5%201.493-1.5zM8.984%208C7.337%208%206%209.344%206%2011s1.337%203%202.984%203c1.648%200%202.985-1.344%202.985-3s-1.337-3-2.985-3zm0%204.5c-.823%200-1.492-.672-1.492-1.5s.669-1.5%201.492-1.5c.824%200%201.493.672%201.493%201.5s-.669%201.5-1.493%201.5zM11.904.588L1.809%2013.844a.376.376%200%2001-.301.156H.404a.375.375%200%2001-.31-.584L10.203.156a.374.374%200%2001.3-.156h1.092c.298%200%20.476.338.308.588z%22%2F%3E%3C%2Fsvg%3E";

function _extends$p() {
  _extends$p = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$p.apply(this, arguments);
}

var _ref$p = /*#__PURE__*/createElement("path", {
  d: "M8 0v6h6v2H8v6H6V8H0V6h6V0h2z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$p({
    width: 14,
    height: 14
  }, props), _ref$p);
}

var PlusSvg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2214%22%20height%3D%2214%22%20viewBox%3D%220%200%2014%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22currentColor%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-159.000000%2C%20-179.000000%29%22%20fill%3D%22currentColor%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28158.000000%2C%20178.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M9%2C1%20L9%2C7%20L15%2C7%20L15%2C9%20L9%2C9%20L9%2C15%20L7%2C15%20L7%2C9%20L1%2C9%20L1%2C7%20L7%2C7%20L7%2C1%20L9%2C1%20Z%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$q() {
  _extends$q = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$q.apply(this, arguments);
}

var _ref$q = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M13.743 12.574L9.91 8.74a5.425 5.425 0 001.05-3.232A5.532 5.532 0 005.46 0 5.436 5.436 0 000 5.468a5.532 5.532 0 005.5 5.508 5.408 5.408 0 003.242-1.061l.004-.003 3.83 3.831a.826.826 0 101.167-1.169zM5.496 9.878a4.426 4.426 0 01-4.4-4.406 4.35 4.35 0 014.368-4.374 4.425 4.425 0 014.4 4.406 4.35 4.35 0 01-4.368 4.374z"
});

function SvgSearch(props) {
  return /*#__PURE__*/createElement("svg", _extends$q({
    width: 14,
    height: 14
  }, props), _ref$q);
}

var SearchSvg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%2214%22%20height%3D%2214%22%20viewBox%3D%220%200%2014%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M13.7430947%2C12.5740557%20L9.91009465%2C8.73955572%20C10.5971654%2C7.80245935%2010.9652265%2C6.66953223%2010.9600947%2C5.50755572%20C10.946985%2C2.47441147%208.49371664%2C0.0175744397%205.46059465%2C5.57178262e-05%20C4.00907481%2C-0.00651157295%202.61521603%2C0.567712287%201.58953064%2C1.59480646%20C0.56384524%2C2.62190064%20-0.00846492859%2C4.01654626%209.46502197e-05%2C5.46805572%20C0.0132043609%2C8.50147611%202.46669652%2C10.958537%205.50009465%2C10.9760557%20C6.66680484%2C10.9811124%207.80387114%2C10.6087552%208.74159465%2C9.91455572%20L8.74559465%2C9.91155572%20L12.5750947%2C13.7430557%20C12.7821435%2C13.9602692%2013.0906604%2C14.0481921%2013.3811096%2C13.9727584%20C13.6715587%2C13.8973248%2013.898302%2C13.6703873%2013.9734871%2C13.3798737%20C14.0486722%2C13.0893602%2013.9604853%2C12.7809186%2013.7430947%2C12.5740557%20L13.7430947%2C12.5740557%20Z%20M5.49609465%2C9.87805572%20C3.06950871%2C9.86409673%201.1067469%2C7.89865842%201.09609465%2C5.47205572%20C1.08954524%2C4.31099854%201.54743104%2C3.19550612%202.36782487%2C2.37389147%20C3.1882187%2C1.55227681%204.30302902%2C1.09273279%205.46409465%2C1.09755572%20C7.89068059%2C1.1115147%209.8534424%2C3.07695301%209.86409465%2C5.50355572%20C9.87064406%2C6.6646129%209.41275826%2C7.78010532%208.59236443%2C8.60171997%20C7.7719706%2C9.42333462%206.65716028%2C9.88287864%205.49609465%2C9.87805572%20Z%22%20id%3D%22Search%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";

function _extends$r() {
  _extends$r = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$r.apply(this, arguments);
}

var _ref$r = /*#__PURE__*/createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  d: "M0 4h7v2H0zM9 4h7v2H9zM0 0h7v2H0zM9 0h7v2H9zM0 8h7v2H0zM9 8h7v2H9zM0 12h7v2H0zM9 12h7v2H9z"
}));

function SvgTable(props) {
  return /*#__PURE__*/createElement("svg", _extends$r({
    width: 16,
    height: 14
  }, props), _ref$r);
}

var TableSvg = "data:image/svg+xml,%3Csvg%20width%3D%2216px%22%20height%3D%2214px%22%20viewBox%3D%220%200%2016%2014%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-108.000000%2C%20-1819.000000%29%22%20fill%3D%22currentColor%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%2874.000000%2C%201812.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%2834.000000%2C%207.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%224%22%20width%3D%227%22%20height%3D%222%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%229%22%20y%3D%224%22%20width%3D%227%22%20height%3D%222%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%227%22%20height%3D%222%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%229%22%20y%3D%220%22%20width%3D%227%22%20height%3D%222%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%228%22%20width%3D%227%22%20height%3D%222%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%229%22%20y%3D%228%22%20width%3D%227%22%20height%3D%222%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%220%22%20y%3D%2212%22%20width%3D%227%22%20height%3D%222%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20x%3D%229%22%20y%3D%2212%22%20width%3D%227%22%20height%3D%222%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$s() {
  _extends$s = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$s.apply(this, arguments);
}

var _ref$s = /*#__PURE__*/createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});

var _ref2$2 = /*#__PURE__*/createElement("path", {
  fill: "#fff",
  d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
});

function SvgTickWhite(props) {
  return /*#__PURE__*/createElement("svg", _extends$s({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24"
  }, props), _ref$s, _ref2$2);
}

var TickWhite = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2024%2024%22%3E%20%20%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h24v24H0z%22%2F%3E%20%20%3Cpath%20fill%3D%22white%22%20d%3D%22M9%2016.2L4.8%2012l-1.4%201.4L9%2019%2021%207l-1.4-1.4L9%2016.2z%22%2F%3E%3C%2Fsvg%3E";

function _extends$t() {
  _extends$t = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$t.apply(this, arguments);
}

var _ref$t = /*#__PURE__*/createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});

var _ref2$3 = /*#__PURE__*/createElement("path", {
  fill: "currentColor",
  d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
});

function SvgTick(props) {
  return /*#__PURE__*/createElement("svg", _extends$t({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24"
  }, props), _ref$t, _ref2$3);
}

var TickSvg = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2024%2024%22%3E%20%20%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h24v24H0z%22%2F%3E%20%20%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M9%2016.2L4.8%2012l-1.4%201.4L9%2019%2021%207l-1.4-1.4L9%2016.2z%22%2F%3E%3C%2Fsvg%3E";

function _extends$u() {
  _extends$u = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$u.apply(this, arguments);
}

var _ref$u = /*#__PURE__*/createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  d: "M5 16V1.964"
}), /*#__PURE__*/createElement("path", {
  d: "M7.734 12.175l-2.745 2.831-2.723-2.802a.76.76 0 00-1.098 0 .818.818 0 000 1.132l3.27 3.37a.76.76 0 001.099 0l3.295-3.397a.819.819 0 000-1.134.76.76 0 00-1.098 0z",
  fill: "currentColor"
}));

function SvgVHeadedArrowDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$u({
    width: 10,
    height: 18
  }, props), _ref$u);
}

var VHeadedArrowDown = "data:image/svg+xml,%3Csvg%20width%3D%2210px%22%20height%3D%2218px%22%20viewBox%3D%220%200%2010%2018%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-393.000000%2C%20-66.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28398.000000%2C%2075.500000%29%20rotate%28-90.000000%29%20translate%28-398.000000%2C%20-75.500000%29%20translate%28390.000000%2C%2071.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%221.5%22%20y1%3D%224.5%22%20x2%3D%2215.5356688%22%20y2%3D%224.5%22%20id%3D%22Line-5%22%20stroke%3D%22currentColor%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M5.79310482%2C2.2348643%20L3.04858819%2C5.065762%20L0.325988734%2C2.26325678%20C0.0223953534%2C1.95010438%20-0.468711585%2C1.95010438%20-0.772304965%2C2.26325678%20C-1.07589835%2C2.57640919%20-1.07589835%2C3.08329854%20-0.772304965%2C3.39561587%20L2.49822372%2C6.7651357%20C2.8018171%2C7.0782881%203.29292404%2C7.0782881%203.59651742%2C6.7651357%20L6.89139851%2C3.36805846%20C7.19499189%2C3.05490605%207.19499189%2C2.54718163%206.89139851%2C2.2348643%20C6.58780513%2C1.9217119%206.0966982%2C1.9217119%205.79310482%2C2.2348643%20Z%22%20id%3D%22DROPDOWN-Copy-6%22%20fill%3D%22currentColor%22%20transform%3D%22translate%283.059547%2C%204.500000%29%20rotate%28-270.000000%29%20translate%28-3.059547%2C%20-4.500000%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$v() {
  _extends$v = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$v.apply(this, arguments);
}

var _ref$v = /*#__PURE__*/createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  d: "M1.5 4.5h14.036"
}), /*#__PURE__*/createElement("path", {
  d: "M5.325 7.234L2.494 4.489l2.802-2.723a.76.76 0 000-1.098.818.818 0 00-1.132 0l-3.37 3.27a.76.76 0 000 1.099l3.397 3.295a.819.819 0 001.134 0 .76.76 0 000-1.098z",
  fill: "currentColor"
}));

function SvgVHeadedArrowLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$v({
    width: 17,
    height: 9
  }, props), _ref$v);
}

var VHeadedArrowLeft = "data:image/svg+xml,%3Csvg%20width%3D%2217px%22%20height%3D%229px%22%20viewBox%3D%220%200%2017%209%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-31.000000%2C%20-71.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%2831.000000%2C%2067.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%280.000000%2C%204.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%221.5%22%20y1%3D%224.5%22%20x2%3D%2215.5356688%22%20y2%3D%224.5%22%20id%3D%22Line-5%22%20stroke%3D%22currentColor%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M5.79310482%2C2.2348643%20L3.04858819%2C5.065762%20L0.325988734%2C2.26325678%20C0.0223953534%2C1.95010438%20-0.468711585%2C1.95010438%20-0.772304965%2C2.26325678%20C-1.07589835%2C2.57640919%20-1.07589835%2C3.08329854%20-0.772304965%2C3.39561587%20L2.49822372%2C6.7651357%20C2.8018171%2C7.0782881%203.29292404%2C7.0782881%203.59651742%2C6.7651357%20L6.89139851%2C3.36805846%20C7.19499189%2C3.05490605%207.19499189%2C2.54718163%206.89139851%2C2.2348643%20C6.58780513%2C1.9217119%206.0966982%2C1.9217119%205.79310482%2C2.2348643%20Z%22%20id%3D%22DROPDOWN-Copy-6%22%20fill%3D%22currentColor%22%20transform%3D%22translate%283.059547%2C%204.500000%29%20rotate%28-270.000000%29%20translate%28-3.059547%2C%20-4.500000%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$w() {
  _extends$w = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$w.apply(this, arguments);
}

var _ref$w = /*#__PURE__*/createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  d: "M15.5 4.5H1.464"
}), /*#__PURE__*/createElement("path", {
  d: "M11.675 1.766l2.831 2.745-2.802 2.723a.76.76 0 000 1.098.818.818 0 001.132 0l3.37-3.27a.76.76 0 000-1.099L12.809.668a.819.819 0 00-1.134 0 .76.76 0 000 1.098z",
  fill: "currentColor"
}));

function SvgVHeadedArrowRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$w({
    width: 17,
    height: 9
  }, props), _ref$w);
}

var VHeadedArrowRight = "data:image/svg+xml,%3Csvg%20width%3D%2217px%22%20height%3D%229px%22%20viewBox%3D%220%200%2017%209%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-354.000000%2C%20-71.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28363.000000%2C%2075.500000%29%20rotate%28-180.000000%29%20translate%28-363.000000%2C%20-75.500000%29%20translate%28355.000000%2C%2071.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%221.5%22%20y1%3D%224.5%22%20x2%3D%2215.5356688%22%20y2%3D%224.5%22%20id%3D%22Line-5%22%20stroke%3D%22currentColor%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M5.79310482%2C2.2348643%20L3.04858819%2C5.065762%20L0.325988734%2C2.26325678%20C0.0223953534%2C1.95010438%20-0.468711585%2C1.95010438%20-0.772304965%2C2.26325678%20C-1.07589835%2C2.57640919%20-1.07589835%2C3.08329854%20-0.772304965%2C3.39561587%20L2.49822372%2C6.7651357%20C2.8018171%2C7.0782881%203.29292404%2C7.0782881%203.59651742%2C6.7651357%20L6.89139851%2C3.36805846%20C7.19499189%2C3.05490605%207.19499189%2C2.54718163%206.89139851%2C2.2348643%20C6.58780513%2C1.9217119%206.0966982%2C1.9217119%205.79310482%2C2.2348643%20Z%22%20id%3D%22DROPDOWN-Copy-6%22%20fill%3D%22currentColor%22%20transform%3D%22translate%283.059547%2C%204.500000%29%20rotate%28-270.000000%29%20translate%28-3.059547%2C%20-4.500000%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

function _extends$x() {
  _extends$x = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$x.apply(this, arguments);
}

var _ref$x = /*#__PURE__*/createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  d: "M5 2v14.036"
}), /*#__PURE__*/createElement("path", {
  d: "M2.266 5.825l2.745-2.831 2.723 2.802a.76.76 0 001.098 0 .818.818 0 000-1.132l-3.27-3.37a.76.76 0 00-1.099 0L1.168 4.691a.819.819 0 000 1.134.76.76 0 001.098 0z",
  fill: "currentColor"
}));

function SvgVHeadedArrowUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$x({
    width: 10,
    height: 18
  }, props), _ref$x);
}

var VHeadedArrowUp = "data:image/svg+xml,%3Csvg%20width%3D%2210px%22%20height%3D%2218px%22%20viewBox%3D%220%200%2010%2018%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%3Cg%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28-422.000000%2C%20-67.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20transform%3D%22translate%28427.000000%2C%2075.500000%29%20rotate%28-270.000000%29%20translate%28-427.000000%2C%20-75.500000%29%20translate%28419.000000%2C%2071.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cline%20x1%3D%221.5%22%20y1%3D%224.5%22%20x2%3D%2215.5356688%22%20y2%3D%224.5%22%20id%3D%22Line-5%22%20stroke%3D%22currentColor%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%3E%3C%2Fline%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M5.79310482%2C2.2348643%20L3.04858819%2C5.065762%20L0.325988734%2C2.26325678%20C0.0223953534%2C1.95010438%20-0.468711585%2C1.95010438%20-0.772304965%2C2.26325678%20C-1.07589835%2C2.57640919%20-1.07589835%2C3.08329854%20-0.772304965%2C3.39561587%20L2.49822372%2C6.7651357%20C2.8018171%2C7.0782881%203.29292404%2C7.0782881%203.59651742%2C6.7651357%20L6.89139851%2C3.36805846%20C7.19499189%2C3.05490605%207.19499189%2C2.54718163%206.89139851%2C2.2348643%20C6.58780513%2C1.9217119%206.0966982%2C1.9217119%205.79310482%2C2.2348643%20Z%22%20id%3D%22DROPDOWN-Copy-6%22%20fill%3D%22currentColor%22%20transform%3D%22translate%283.059547%2C%204.500000%29%20rotate%28-270.000000%29%20translate%28-3.059547%2C%20-4.500000%29%20%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";
/* eslint-disable no-duplicate-imports */

const AlertIcon = AlertSvg;
const ArrowIcon = ArrowSvg;
const AscendingIcon = AscendingSvg;
const AxisIcon = AxisSvg;
const BurgerMenuIcon = BurgerMenuSvg;
const BurgerMenuBackIcon = BurgerMenuBackSvg;
const CalendarIcon = CalendarSvg;
const ChartIcon = ChartSvg;
const ChartBarIcon = ChartBarSvg;
const ChevronDownIcon = ChevronDownSvg;
const ChevronRightIcon = ChevronRightSvg;
const ChevronThinIcon = ChevronThin;
const ChevronUpIcon = ChevronUpSvg;
const CloseIcon = CloseSvg;
const CurrencyGbpIcon = CurrencyGbpSvg;
const DashIcon = DashSvg;
const DashWhiteIcon = DashWhiteSvg;
const DescendingIcon = DescendingSvg;
const DownloadIcon = DownloadSvg;
const FilterOutlineIcon = FilterOutlineSvg;
const FilterIcon = FilterSvg;
const LargerChevronRightIcon = LargerChevronRightSvg;
const MenuCloseIcon = MenuCloseSvg;
const OptionsIcon = OptionsSvg;
const PercentageIcon = PercentageSvg;
const PlusIcon = PlusSvg;
const SearchIcon = SearchSvg;
const TableIcon = TableSvg;
const TickIcon = TickSvg;
const TickWhiteIcon = TickWhite;
const VHeadedArrowDownIcon = VHeadedArrowDown;
const VHeadedArrowLeftIcon = VHeadedArrowLeft;
const VHeadedArrowRightIcon = VHeadedArrowRight;
const VHeadedArrowUpIcon = VHeadedArrowUp;

function _extends$y() {
  _extends$y = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$y.apply(this, arguments);
}

var _ref$y = /*#__PURE__*/createElement("path", {
  fill: "#aa1263",
  d: "M149.75 13.83h-99.5L.5 100l49.75 86.17h33.34l50.16-86.89h27.81l-50.16 86.89h38.35L199.5 100z"
});

function SvgRiskFirstLogo(props) {
  return /*#__PURE__*/createElement("svg", _extends$y({
    viewBox: "0 0 200 200"
  }, props), _ref$y);
}

var RiskFirstLogoSvg = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%20200%20200%22%20style%3D%22enable-background%3Anew%200%200%20200%20200%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23AA1263%3B%7D%3C%2Fstyle%3E%3Cpolygon%20class%3D%22st0%22%20points%3D%22149.75%2C13.83%2050.25%2C13.83%200.5%2C100%2050.25%2C186.17%2083.59%2C186.17%20133.75%2C99.28%20161.56%2C99.28%20111.4%2C186.17%20149.75%2C186.17%20199.5%2C100%20%22%2F%3E%3C%2Fsvg%3E";

function _extends$z() {
  _extends$z = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$z.apply(this, arguments);
}

var _ref$z = /*#__PURE__*/createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  d: "M58.547 12v-1.227H52.82v-4.03h4.93V5.515h-4.93V1.859h5.649V.625H51.32V12h7.227zm6.07 0V1.86h3.656V.624h-8.796v1.234h3.648V12h1.492zm12.242 0v-1.227h-5.39V.625H69.96V12h6.898z",
  fillRule: "nonzero"
}), /*#__PURE__*/createElement("path", {
  d: "M2.483 6.177h1.93c1.155 0 2.183-.247 2.183-1.65 0-1.401-1.028-1.647-2.183-1.647h-1.93v3.297zM0 1h5.093C7.91 1 9 2.74 9 4.528c0 1.787-1.091 3.528-3.907 3.528h-2.61V12H0V1zM10 1h7v2.034h-4.81v2.542h4.169v1.88h-4.17V12H10V1M21.778 8.08c-.333.309-1.028.324-1.639.441-.611.132-1.167.352-1.167 1.116 0 .778.57.969 1.209.969 1.541 0 1.597-1.292 1.597-1.747V8.08zm-4.556-1.54C17.333 4.586 18.986 4 20.597 4c1.43 0 3.153.337 3.153 2.158v3.948c0 .69.07 1.38.25 1.688h-2a3.258 3.258 0 01-.139-.733c-.625.69-1.541.939-2.416.939C18.083 12 17 11.28 17 9.725c0-1.718 1.222-2.129 2.445-2.305 1.208-.19 2.333-.147 2.333-.998 0-.895-.583-1.028-1.278-1.028-.75 0-1.236.323-1.305 1.145h-1.973zM25 4.21h2.027v1.447h.03C27.447 4.677 28.498 4 29.534 4c.15 0 .33.03.466.075v1.989a3.862 3.862 0 00-.766-.075c-1.561 0-2.102 1.13-2.102 2.5V12H25V4.21M33.992 10.43c1.45 0 1.884-1.219 1.884-2.423 0-1.218-.433-2.437-1.884-2.437-1.435 0-1.869 1.219-1.869 2.437 0 1.204.434 2.423 1.87 2.423zm0-6.43C36.43 4 38 5.585 38 8.007 38 10.415 36.43 12 33.992 12 31.57 12 30 10.415 30 8.007 30 5.585 31.57 4 33.992 4zM44.785 7.185c-.201-1.057-.682-1.615-1.752-1.615-1.396 0-1.8 1.028-1.83 1.615h3.582zm-3.583 1.321c.062 1.321.745 1.924 1.97 1.924.884 0 1.598-.514 1.737-.984h1.94c-.621 1.79-1.94 2.554-3.754 2.554C40.566 12 39 10.356 39 8.007 39 5.732 40.66 4 43.095 4c2.73 0 4.048 2.172 3.893 4.506h-5.786zM46.242 2.356h.29c.183 0 .32-.029.32-.233 0-.18-.188-.209-.336-.209h-.274v.442zm-.324-.702h.617c.41 0 .64.132.64.497 0 .309-.187.43-.43.45l.439.733h-.34l-.399-.718h-.203v.718h-.324v-1.68zm.582 2.025c.605 0 1.101-.497 1.101-1.183 0-.682-.496-1.175-1.1-1.175-.614 0-1.103.493-1.103 1.175 0 .686.489 1.183 1.102 1.183zM46.5 1c.793 0 1.5.585 1.5 1.496C48 3.41 47.293 4 46.5 4S45 3.41 45 2.496C45 1.586 45.707 1 46.5 1z"
}));

function SvgEtlLogo(props) {
  return /*#__PURE__*/createElement("svg", _extends$z({
    width: 77,
    height: 13,
    "aria-label": "BC0DE546-DF2C-4991-A886-D5DEECD890D8"
  }, props), _ref$z);
}

const squareLogoRenderer = Component => ({
  size
}) => React__default.createElement(Component, {
  height: size,
  width: size
});

const RiskFirstLogoComponent = squareLogoRenderer(SvgRiskFirstLogo);
const RiskFirstLogo = RiskFirstLogoSvg;
export { AlertIcon, SvgAlert as AlertIconComponent, ArrowIcon, SvgArrow as ArrowIconComponent, AscendingIcon, SvgAscending as AscendingIconComponent, AxisIcon, SvgAxis as AxisIconComponent, BurgerMenuBackIcon, SvgBurgerMenuBack as BurgerMenuBackIconComponent, BurgerMenuIcon, SvgBurgerMenu as BurgerMenuIconComponent, CalendarIcon, SvgCalendar as CalendarIconComponent, ChartBarIcon, SvgChartBar as ChartBarIconComponent, ChartIcon, SvgChart as ChartIconComponent, ChevronDownIcon, SvgChevronDown as ChevronDownIconComponent, ChevronRightIcon, SvgChevronRight as ChevronRightIconComponent, ChevronThinIcon, SvgChevronThin as ChevronThinIconComponent, ChevronUpIcon, SvgChevronUp as ChevronUpIconComponent, CloseIcon, SvgClose as CloseIconComponent, CurrencyGbpIcon, SvgCurrencyGbp as CurrencyGbpIconComponent, DashIcon, SvgDash as DashIconComponent, DashWhiteIcon, SvgDashWhite as DashWhiteIconComponent, DescendingIcon, SvgDescending as DescendingIconComponent, DownloadIcon, SvgDownload as DownloadIconComponent, SvgEtlLogo as ETLLogoReactComponent, FilterIcon, SvgFilter as FilterIconComponent, FilterOutlineIcon, SvgFilterOutline as FilterOutlineIconComponent, SvgLargerChevronRight as LargerChevronRightComponent, LargerChevronRightIcon, MenuCloseIcon, SvgMenuClose as MenuCloseIconComponent, OptionsIcon, SvgOptions as OptionsIconComponent, PercentageIcon, SvgPercentage as PercentageIconComponent, PlusIcon, SvgPlus as PlusIconComponent, RiskFirstLogo, RiskFirstLogoComponent, SearchIcon, SvgSearch as SearchIconComponent, TableIcon, SvgTable as TableIconComponent, TickIcon, SvgTick as TickIconComponent, TickWhiteIcon, SvgTickWhite as TickWhiteIconComponent, SvgVHeadedArrowDown as VHeadedArrowDownComponent, VHeadedArrowDownIcon, SvgVHeadedArrowLeft as VHeadedArrowLeftComponent, VHeadedArrowLeftIcon, SvgVHeadedArrowRight as VHeadedArrowRightComponent, VHeadedArrowRightIcon, SvgVHeadedArrowUp as VHeadedArrowUpComponent, VHeadedArrowUpIcon };
//# sourceMappingURL=index.js.map
